/* tslint:disable:max-line-length */
import { template } from 'lodash';

import { LoginPagePath } from '../components/pages/account/Login';
import { LogoutPagePath } from '../components/pages/account/Logout';

const loginRedirectUrl = encodeURIComponent(`https://${location.hostname}${LoginPagePath}`);
const logoutRedirectUrl = encodeURIComponent(`https://${location.hostname}${LogoutPagePath}`);
const scope = encodeURIComponent('email profile openid phone');

export const compileFederatedLoginUrl = template(`https://<%= cognito_domain_url %>/oauth2/authorize?redirect_uri=${loginRedirectUrl}&response_type=token&client_id=<%= client_id %>&scope=${scope}`);
export const compileLogoutUrl = template(`https://<%= cognito_domain_url %>${LogoutPagePath}?logout_uri=${logoutRedirectUrl}&client_id=<%= client_id %>`);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/authentication.ts